import React from 'react';
import { Link } from 'react-router';
import placeholderImage from 'assets/img/placeholder.png';
import classes from './search-patagonia-card.scss';
const SearchPatagoniaCard = props => {
  const {
    product: {
      _id,
      image,
      link,
      childProductIds = [],
      title = ''
    },
    onLinkClick
  } = props;
  const patagoniaProductsQuantity = childProductIds.length;
  const patagoniaTitle = title.replace('__', ' ');
  return /*#__PURE__*/React.createElement(Link, {
    key: _id,
    onClick: onLinkClick,
    to: link,
    className: classes.row
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.narrowCell
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.searchImage,
    src: image || placeholderImage,
    alt: "Product image"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.patagoniaCell
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.patagoniaProductName
  }, patagoniaTitle), /*#__PURE__*/React.createElement("div", {
    className: classes.patagoniaText
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.patagoniaQuantity
  }, patagoniaProductsQuantity), patagoniaProductsQuantity === 1 ? 'Product available' : 'Products available'), /*#__PURE__*/React.createElement("div", {
    className: classes.patagoniaText
  }, "upon request")));
};
export default SearchPatagoniaCard;